import { render, staticRenderFns } from "./CommonTransition.vue?vue&type=template&id=038ce88f&scoped=true"
import script from "./CommonTransition.vue?vue&type=script&lang=js"
export * from "./CommonTransition.vue?vue&type=script&lang=js"
import style0 from "./CommonTransition.vue?vue&type=style&index=0&id=038ce88f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038ce88f",
  null
  
)

export default component.exports